import { useState, useEffect } from 'react';

function useIsMobile(breakpoint: number = 1023): boolean {
    const [isMobile, setIsMobile] = useState<boolean>(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const checkScreenSize = () => {
                setIsMobile(window.innerWidth <= breakpoint);
            };
            checkScreenSize();
            window.addEventListener('resize', checkScreenSize);
            return () => {
                window.removeEventListener('resize', checkScreenSize);
            };
        }
    }, [breakpoint]);

    return isMobile;
}

export default useIsMobile;
